var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Rating } from '../rating';
import styled from 'styled-components';
import { RECIPE_CARD_CONTAINER, RECIPE_CARD_IMAGE, RECIPE_CARD_TITLE, } from '../../constants/class-names';
import { getMainImageUrls } from '../../util/image';
import { MIN_WIDTH_EXTRA_LARGE, MIN_WIDTH_MEDIUM } from '../../constants/styles';
var RecipeCardContainer = styled.div({
    cursor: 'pointer',
});
var RecipeCardImage = styled.img((_a = {
        objectPosition: 'center center',
        width: '100%',
        borderRadius: '4px'
    },
    _a["".concat(RecipeCardContainer, ":hover &")] = {
        boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.2)',
    },
    _a));
var RecipeCardTitle = styled.h2((_b = {
        fontFamily: 'var(--font-family-secondary)',
        fontSize: '24px',
        fontWeight: 'normal',
        letterSpacing: 'normal',
        lineHeight: 1.42,
        color: '#1d1e1f',
        marginTop: '15px',
        marginBottom: '6px'
    },
    _b["".concat(RecipeCardContainer, ":hover &")] = {
        textDecoration: 'underline',
    },
    _b));
export var RecipeCard = memo(function (_a) {
    var recipe = _a.recipe, _b = _a.showRating, showRating = _b === void 0 ? true : _b;
    var urls = getMainImageUrls(recipe.media, '16x9');
    return (_jsxs(RecipeCardContainer, __assign({ className: RECIPE_CARD_CONTAINER }, { children: [urls && (_jsx(RecipeCardImage, { className: RECIPE_CARD_IMAGE, alt: "Recipe", src: urls.src, srcSet: urls.srcSet, sizes: "\n            (min-width: ".concat(MIN_WIDTH_MEDIUM, ") 50vw,\n            (min-width: ").concat(MIN_WIDTH_EXTRA_LARGE, ") 312w,\n            100vw\n          ") }, void 0)), _jsx(RecipeCardTitle, __assign({ className: RECIPE_CARD_TITLE }, { children: recipe.name }), void 0), showRating ? _jsx(Rating, { value: Number(recipe.rating) }, void 0) : null] }), void 0));
});
